module.exports = __webpack_public_path__ + "assets/img/d82e-tf.svg";